import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Forgetpassword.css";
import { FaRegArrowAltCircleLeft } from "react-icons/fa";

export const Forgetpassword = () => {
  const [showOTPInput, setShowOTPInput] = useState(false);
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  const [buttonText, setButtonText] = useState("Send Mail");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSendingMail, setIsSendingMail] = useState(false);

  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const handleSendMail = async () => {
    try {
      setIsSendingMail(true);

      const response = await fetch(`${API_BASE}/sendOTP`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setShowOTPInput(true);
        setButtonText("Submit OTP");
      } else if (response.status === 400) {
        alert("Email address does not exist");
      } else {
        alert("Error sending OTP");
      }
    } catch (error) {
      console.error("Send OTP error:", error);
      alert("Network error. Please try again.");
    } finally {
      setIsSendingMail(false);
    }
  };

  const handleVerifyOTP = async () => {
    try {
      const response = await fetch(`${API_BASE}/verifyOTP`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp }),
      });

      const data = await response.json();

      if (data.success) {
        setShowPasswordFields(true);
        setShowOTPInput(false);
        setButtonText("Reset Password");
      } else {
        alert("OTP not matched");
      }
    } catch (error) {
      console.error("Verify OTP error:", error);
      alert("Network error");
    }
  };

  const handleResetPassword = async () => {
    if (newPassword !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    try {
      const response = await fetch(`${API_BASE}/updatePassword`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, newPassword }),
      });

      const data = await response.json();

      if (data.success) {
        alert("Password updated successfully");
        navigate("/land");
      } else {
        alert("Failed to update password");
      }
    } catch (error) {
      console.error("Reset password error:", error);
      alert("Network error");
    }
  };

  return (
    <div className="fp_forgetboxouter d-flex flex-column justify-content-center align-items-center">
      <Link className="fp_back" to="/land">
        <p className="zoom-effect-p">
          <FaRegArrowAltCircleLeft /> Login
        </p>
      </Link>

      <div className="fp_forgetpass">
        {!showPasswordFields && (
          <>
            <input
              placeholder="Enter your Email id"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={showOTPInput}
              className="lo-inp"
            />

            {showOTPInput && (
              <input
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                className="lo-inp"
              />
            )}
          </>
        )}

        {showPasswordFields && (
          <>
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="lo-inp"
            />
            <input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="lo-inp"
            />
          </>
        )}

        <button
          className="loinp-but"
          disabled={isSendingMail}
          onClick={
            showPasswordFields
              ? handleResetPassword
              : showOTPInput
              ? handleVerifyOTP
              : handleSendMail
          }
        >
          {isSendingMail ? "Sending Mail..." : buttonText}
        </button>
      </div>
    </div>
  );
};
